<div class="tabla-wrapper">

  <div class="tabla-scroll">

    <table class="tabla">

      <!-- =============================
           HEADER
      ============================== -->

      <thead>

        <tr>

          <th class="col-codigo">
            Código
          </th>

          <th class="col-medicamento">
            Medicamento
          </th>

          <th class="col-tipo">
            Tipo
          </th>

          <th
            *ngFor="let sucursal of sucursalesSeleccionadas"
            class="col-sucursal"
          >
            {{ sucursal }}
          </th>

          <th class="col-total">
            Total
          </th>

          <th class="col-stock">
            Stock
          </th>

        </tr>

      </thead>

      <!-- =============================
           BODY
      ============================== -->

      <tbody>

        <!-- =============================
             SKELETON LOADING
        ============================== -->

        <ng-container *ngIf="loading">

          <tr *ngFor="let item of [1,2,3,4,5,6,7,8]">

            <td [attr.colspan]="sucursalesSeleccionadas.length + 5">

              <div class="skeleton-row"></div>

            </td>

          </tr>

        </ng-container>


        <!-- =============================
             DATOS REALES
        ============================== -->

        <ng-container *ngIf="!loading">

          <tr
            *ngFor="
              let med of medicamentosPaginados;
              trackBy: trackByMedicamento
            "
          >

            <!-- CODIGO -->

            <td class="col-codigo">
              {{ med.codigo }}
            </td>


            <!-- MEDICAMENTO -->

            <td class="col-medicamento">

              <strong>
                {{ med.nombre }}
              </strong>

            </td>


            <!-- TIPO / FORMATO -->

            <td class="col-tipo">

              <span class="badge-tipo">
                {{ med.rotacion }}
              </span>

            </td>


            <!-- INPUTS POR SUCURSAL -->

            <td
              *ngFor="let sucursal of sucursalesSeleccionadas"
              class="col-sucursal"
            >

              <div class="cantidad-box">

                <input
                  type="number"
                  min="0"
                  [ngModel]="obtenerCantidad(med.productId, sucursal)"
                  (ngModelChange)="actualizarCantidad(med.productId, sucursal, $event)"
                  [ngModelOptions]="{ standalone: true }"
                />

              </div>

            </td>


            <!-- TOTAL -->

            <td
              class="col-total"
              [ngClass]="{
                'total-error':
                  calcularTotal(med.productId) > obtenerStock(med.productId)
              }"
            >

              {{ calcularTotal(med.productId) }}

              <span
                class="warning"
                *ngIf="calcularTotal(med.productId) > obtenerStock(med.productId)"
              >
                ⚠
              </span>

            </td>


            <!-- STOCK -->

            <td class="col-stock">

              {{ obtenerStock(med.productId) }}

            </td>

          </tr>

        </ng-container>

      </tbody>

    </table>

  </div>


  <!-- =============================
       FOOTER
  ============================== -->

  <div class="tabla-footer">

    Mostrando
    {{ medicamentosMostrados }}
    de
    {{ medicamentos.length }}
    medicamentos

  </div>

</div>


<!-- =============================
     PAGINACION
============================== -->

<app-paginacion
  [paginaActual]="paginaActual"
  [totalPaginas]="totalPaginas"
  (paginaChange)="cambiarPagina($event)"
>
</app-paginacion>
